import PlayStore from '@/assets/images/app-badges/play-store.svg';
import AppStore from '@/assets/images/app-badges/app-store.svg';
import PlayStoreBlack from '@/assets/images/app-badges/play-store-black.svg';
import AppStoreBlack from '@/assets/images/app-badges/app-store-black.svg';
import { APP_LINKS, onClickAndroid, onClickIOS } from './common';
import { cn } from '@/lib/utils';

interface AppLinksProps {
  isCenter?: boolean;
  isBlack?: boolean;
  isFromFooter?: boolean;
}

const AppLinks = ({
  isCenter = false,
  isBlack = false,
  isFromFooter = false,
}: AppLinksProps) => {
  return (
    <div
      className={cn('w-full mt-6 mb-20 flex flex-row gap-3 md:gap-[23px]', {
        'justify-center': isCenter,
      })}
      data-component="CMSAppLinks"
    >
      <a onClick={onClickIOS} href={APP_LINKS.appStore} target="_blank">
        <div className={cn('flex h-full', {})}>
          <img
            className={cn({
              'h-full': isBlack,
              'h-10': isFromFooter,
            })}
            src={isBlack ? AppStoreBlack : AppStore}
            alt="appstore"
            loading="lazy"
          />
        </div>
      </a>
      <a onClick={onClickAndroid} href={APP_LINKS.playStore} target="_blank">
        <div className={cn('flex h-full', {})}>
          <img
            className={cn({
              'h-full': isBlack,
              'h-10': isFromFooter,
            })}
            src={isBlack ? PlayStoreBlack : PlayStore}
            alt="playstore"
            loading="lazy"
          />
        </div>
      </a>
    </div>
  );
};

export default AppLinks;
